import React, { useEffect, useRef, useState } from "react";
import mapIcon from "../../assets/marker.png";
import {
  acresToSquareKilometers,
  squareKilometersToAcres,
} from "../../ReusableFunctions/reusableFunctions";
import dateFormat from "dateformat";
import Loading from "../../ReusableFunctions/Loader";
import {
  STATUS,
  PRICE_BY_TYPES
} from "../../appConstants";
import {
  applyDiscount,
  quickRequestUpdateAPI,
  updateRequest,
} from "../../apis/requests";
import LoaderComponent from "../../ReusableComponents/LoaderComponent";

const BesRequestDetailsSection = React.forwardRef(({
  isLoading,
  request,
  requests,
  sprayingRequest,
  setSprayingRequest,
  onRequestUpdate,
}, ref) => {
  const [dronePilots, setDronePilots] = useState([]);
  const [selectedDroneUIN, setSelectedDroneUIN] = useState(null);
  const [droneType, setDroneType] = useState(null);
  const [isInputEditable, setisInputEditable] = useState(false);
  const [isEditingPilot, setIsEditingPilot] = useState(false);
  const [isEditingDroneUIN, setIsEditingDroneUIN] = useState(false);

  useEffect(() => {
    Loading.set(true);
    setIsEditingPilot(false);
    setIsEditingDroneUIN(false);
    setSelectedDroneUIN(null);
    setDroneType(null);
    setSprayingRequest({
      ...request,
      service_completed_area:
        request?.service_completed_area === 0 ||
          request?.service_completed_area === null
          ? ""
          : request?.price_by == "acre"
            ? squareKilometersToAcres(request?.service_completed_area).toFixed(2)
            : request?.service_completed_area,
    });
    Loading.set(false);
  }, [request]);

  useEffect(() => {
    const isEditableStatus = [
      STATUS.ACCEPTED,
      STATUS.RESCHEDULED,
      STATUS.OUT_FOR_SERVICE,
      STATUS.PLACED,
    ].includes(sprayingRequest.status);
    setisInputEditable(
      isEditableStatus || request?.status === STATUS.RESCHEDULED
    );
  }, [sprayingRequest.status]);

  const SingleField = ({ label, value, isEditable }) => {
    return (
      <div className="flex items-center">
        <span className="font-manrope font-[500] text-[15px] custom-lg:text-[16px]  text-[#3B3B3B] mr-1">
          {label} :
        </span>
        <span className="flex items-center">
          {value}
          {isEditable && (
            <span className="ml-2 text-[#0F5EFF] font-manrope text-[15px] cursor-pointer font-[600] underline  ">
              Change
            </span>
          )}
        </span>
      </div>
    );
  };

  useEffect(() => {
    if(requests.length == 0) {
      request = {};
    }
    console.log(request);
  },[]);

  console.log(!requests.length);

  return (
    <>

      {isLoading ? (
        <div className="w-[75%]">
          <LoaderComponent width={"3%"} height={"3%"} />
        </div>
      ) : 
      
      !requests.length ? (
        <div className="flex justify-center items-center w-full h-full font-manrope text-[#3B3B3B] text-lg font-semibold">
          No requests to show details
        </div>
      ) :
        (
        <div
          style={{
            fontFamily: "Manrope !important",
          }}
          className="font-manrope [&>*]:font-inherit [&>*]:text-inherit w-[100%] max-h-full overflow-y-scroll border-r border-r-[#D9D9D9] font-manrope"
        >
          <div className="bg-[#D9D9D9]/30 px-10 py-3 text-sm text-[#3B3B3B] items-center gap-[0.6rem] flex">
            <img src={mapIcon} width={16} height={16} alt={"map-icon"}></img>
            <span className="">{request?.field_address}</span>
          </div>
          <div className="w-full px-4 py-4 custom-lg:px-10">
            {/* customer details section  */}
            <div className="w-full flex justify-between mb-5 ">
              <div className="flex flex-col">
                <div className=" flex items-center gap-3">
                <span className="text-[17px] text-[#1E1E1E] font-[600] font-manrope ">
                  {/* {request?.user_name ? "X".repeat(5) + " " + "X".repeat(request.user_name.length - 5) : "XXXXX XXXX"} */}
                  {"XXXXX XXXX"}
                </span>
                 {/* <div className="w-[50px] flex justify-center border border-[#0F5EFF] rounded-md items-center bg-[#0F5EFF]/15">
                  <span className="font-manrope text-[14px] text-[#0F5EFF] font-[550]">BES</span>
                 </div> */}
                </div>
                <span className="text-[14px] font-manrope text-[#3B3B3B] font-[500]">
                  Contact No. {"XXXXXXXXXX"}
                </span>
              </div>
              <span className="text-[14px] font-manrope text-[#3B3B3B] font-[500">
                Request No.{" "}
                <span className="font-[600]">#{request?.req_number}</span>{" "}
              </span>
            </div>
            <div className=" h-[5px]  border-b border-b-[##BFC8D9]"></div>
            {/* service details  */}
            <div className="py-5">
              <h4 className="font-manrope font-[700] text-[18px] text-[#1E1E1E]">
                Service Details{" "}
              </h4>
              <div className="grid grid-cols-2  gap-x-[10px]  gap-y-3 w-[100%] my-3">
                <SingleField label={"Crop"} value={request?.crop_name || "-"} />
                <SingleField
                  label={"Requested Area"}
                  value={
                    request?.field_area
                      ? `${request.price_by === "acre"
                        ? squareKilometersToAcres(request.field_area)
                        : request.field_area} ${request.price_by === "acre" ? "Acre" : "Tank"}`
                      : "-"
                  }
                />
                <SingleField
                  label={"AgroChemical"}
                  value={request?.pesticides || "-"}
                />
                <SingleField
                  label={"Completed Area"}
                  value={
                    request?.service_completed_area
                      ? `${request.price_by === "acre"
                        ? squareKilometersToAcres(request.service_completed_area)
                        : request.service_completed_area} ${request.price_by === "acre" ? "Acre" : "Tank"}`
                      : "-"
                  }
                />
                <SingleField
                  label={"Received On"}
                  value={
                    request?.date_created
                      ? dateFormat(request.date_created, "dd/mm/yyyy")
                      : "-"
                  }
                />
              </div>
            </div>
            <div className=" h-[5px] border-b border-b-[##BFC8D9]"></div>
            {/* resource Details  */}
            <div className="py-5">
              <h4 className="font-manrope font-[700] text-[18px] text-[#1E1E1E]">
                Resource Details{" "}
              </h4>
              <div className="grid grid-cols-2 gap-x-[10px]  gap-y-3 w-[100%] my-3">
                <div className="flex flex-col">
                  <SingleField
                    label={"Assigned Pilot"}
                    value={

                      <div className="flex gap-4">
                        <span className="font-manrope font-[600] text-[16px] text-[#1E1E1E] ">
                          {dronePilots.find(
                            (p) => p.id === sprayingRequest?.drone_pilot
                          )?.first_name || "-"}
                        </span>
                      </div>
                    }
                  />
                </div>

                <SingleField
                  label={"Assigned Drone "}
                  value={
                    <div className="flex gap-4">
                      <span className="font-manrope font-[600] text-[16px] text-[#1E1E1E] ">
                        {selectedDroneUIN || "-"}
                      </span>
                      { }
                    </div>
                  }
                />

                <SingleField
                  label={"Assinged Drone Type"}
                  value={droneType || "-"}
                />
                <SingleField
                  label={"Schedule on"}
                  value={dateFormat(request?.time, "dd/mm/yyyy") || "-"}
                />
              </div>
            </div>
            <div className=" h-[5px] border-b border-b-[#BFC8D9]"></div>
          </div>
        </div>
      )}
    </>
  );
});
export default BesRequestDetailsSection;
